import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentCategoryData, setRelatedProducts } from "../store/slice"; 
import { fetchRelaPro } from "./util";
import "./Breadcrumb.css";

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pathnames = location.pathname.split("/").filter((x) => x);
  const { services = [], products = {} } = useSelector((state) => state.data || {});

  const allCategories = [];
  const allSubCategories = [];
  const allProducts = [];

  if (products.categories) {
    products.categories.forEach((category) => {
      allCategories.push(category);

      if (category.subCat) {
        category.subCat.forEach((subCategory) => {
          allSubCategories.push({ ...subCategory, parentCatSlug: category.categorySlug });

          if (subCategory.products) {
            allProducts.push(...subCategory.products);
          }
        });
      }

      if (category.products) {
        allProducts.push(...category.products);
      }
    });
  }

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleCategoryClick = (categorySlug) => {
    const matchedCategory = allCategories.find(
      (category) => category.categorySlug === categorySlug
    );
    const firstProduct = matchedCategory?.products?.[0];

    dispatch(setCurrentCategoryData({ cat: categorySlug, subCat: '' }));

    if (firstProduct) {
      dispatch(setRelatedProducts(fetchRelaPro([firstProduct], categorySlug, '', '')));
    } else {
      dispatch(setRelatedProducts([]));
    }

    navigate(`/product-page/${categorySlug}`, {
      state: { product: firstProduct, category: matchedCategory },
    });
  };

  const handleSubCategoryClick = (subCategorySlug) => {
    const matchedSubCat = allSubCategories.find(
      (subCat) => subCat.subCategorySlug === subCategorySlug
    );
    const parentCategory = allCategories.find(
      (cat) => cat.categorySlug === matchedSubCat?.parentCatSlug
    );

    if (matchedSubCat && parentCategory) {
      dispatch(setCurrentCategoryData({
        cat: parentCategory.categorySlug,
        subCat: matchedSubCat.subCategorySlug,
      }));

      dispatch(setRelatedProducts([]));

      navigate(`/product-page/${parentCategory.categorySlug}/${matchedSubCat.subCategorySlug}`, {
        state: {
          category: parentCategory,
          subCategory: matchedSubCat,
        },
      });
    }
  };

  return (
    <nav className="breadcrumb">
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        let displayName = decodeURIComponent(name).replace(/-/g, " ");
        if (name === "service-description") displayName = "Services";
        if (name === "products" || name === "product-page") displayName = "Products";

        const matchedCategory = allCategories.find((cat) => cat.categorySlug === name);
        const matchedSubCategory = allSubCategories.find((sub) => sub.subCategorySlug === name);
        const matchedProduct = allProducts.find((product) => product.productSlug === name);

        if (matchedCategory) displayName = matchedCategory.category;
        if (matchedSubCategory) displayName = matchedSubCategory.subCatName;
        if (isLast && matchedProduct) displayName = matchedProduct.prodName;

        displayName = capitalizeFirstLetter(displayName);

        return (
          <span key={name} className="breadcrumb-item">
            {index > 0 && <span className="breadcrumb-separator">›</span>}

            {displayName === "Products" ? (
              <Link
                to="/product-page"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setCurrentCategoryData({ cat: '', subCat: '' }));
                  dispatch(setRelatedProducts([]));
                  navigate("/product-page");
                }}
                className="breadcrumb-link"
              >
                {displayName}
              </Link>
            ) : displayName === "Services" ? (
              <span className="breadcrumb-disabled">{displayName}</span>
            ) : isLast ? (
              <span className="breadcrumb-disabled breadcrumb-current">{displayName}</span>
            ) : matchedSubCategory ? (
              <Link
                to={routeTo}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubCategoryClick(name);
                }}
                className="breadcrumb-link"
              >
                {displayName}
              </Link>
            ) : matchedCategory ? (
              <Link
                to={routeTo}
                onClick={(e) => {
                  e.preventDefault();
                  handleCategoryClick(name);
                }}
                className="breadcrumb-link"
              >
                {displayName}
              </Link>
            ) : (
              <span className="breadcrumb-disabled">{displayName}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;